var map = {
	"./aurora-desktop.jpg": "9c34",
	"./aurora-desktop.webp": "9b7e",
	"./aurora-mobile.jpg": "6cd8",
	"./aurora-mobile.webp": "3df8",
	"./background.png": "30b3",
	"./creamy-desktop.jpg": "86a9",
	"./creamy-desktop.webp": "daf9",
	"./creamy-mobile.jpg": "0c71",
	"./creamy-mobile.webp": "2f07",
	"./everydayink-desktop.jpg": "70ef",
	"./everydayink-desktop.webp": "b091",
	"./everydayink-mobile.jpg": "9907",
	"./everydayink-mobile.webp": "8490",
	"./feature-desktop.jpg": "4d85",
	"./feature-desktop.webp": "eee6",
	"./feature-mobile.jpg": "44ff",
	"./feature-mobile.webp": "f469",
	"./logo.png": "cf05",
	"./mrsmith-desktop.jpg": "7cba",
	"./mrsmith-desktop.webp": "d67f",
	"./mrsmith-mobile.jpg": "34f6",
	"./mrsmith-mobile.webp": "c4ec",
	"./pbms-desktop.jpg": "a4fa",
	"./pbms-desktop.webp": "b723",
	"./pbms-mobile.jpg": "181e",
	"./pbms-mobile.webp": "c4c7",
	"./tb-1.jpg": "7e77",
	"./tb-2.jpg": "df8c",
	"./tb-3.jpg": "704d",
	"./tb-4.jpg": "650e",
	"./tb-4.webp": "748e",
	"./tb-5.jpg": "dc95",
	"./toscana-desktop.jpg": "1358",
	"./toscana-desktop.webp": "151d",
	"./toscana-mobile.jpg": "82d0",
	"./toscana-mobile.webp": "0fa4",
	"./waxlight-desktop.jpg": "ee5e",
	"./waxlight-desktop.webp": "2185",
	"./waxlight-mobile.jpg": "a212",
	"./waxlight-mobile.webp": "b40d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";